import 'regenerator-runtime/runtime';
import '@/assets/common.css';
import { createApp } from 'vue';
import { vMaska } from 'maska/vue';
import vuetify from '@/plugins/vuetify';
import App from './App.vue';
import router from './router';
import store from './store';

const app = createApp(App);
const host = window.location.hostname;
if ((window.ENV_CONFIG && Object.keys(window.ENV_CONFIG).length > 0) || (/localhost|127\.0\.0\.1/.test(host))) {
    app.directive('mask', vMaska);
    app.use(router);
    app.use(store);
    app.use(vuetify);
    app.mount('#app');
} else {
  throw new Error('APPLICATION STARTUP FAILED: window.ENV_CONFIG is missing or empty. Helm configuration required.');
}